import {injectable} from "inversify";
import TeamFieldBasedCurrency from "@/modules/action-points/services/TeamFieldBasedCurrency";
import {GateTypeEnum} from "@/modules/action-points/enums";

@injectable()
export default class TrainingGKActionPointsCurrency extends TeamFieldBasedCurrency {
  protected getFieldName(): 'actionPointsTrainingGK' {
    return 'actionPointsTrainingGK';
  }

  protected getType(): GateTypeEnum {
    return GateTypeEnum.TRAINING_GK;
  }
}
